import { render } from "./PewPewChart.vue?vue&type=template&id=676c459f"
import script from "./PewPewChart.vue?vue&type=script&lang=js"
export * from "./PewPewChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__